import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}><g fill="#D8D8D8" fillRule="evenodd"><path d="M9.17 7.29l7.54 7.54a1.33 1.33 0 11-1.88 1.88L7.29 9.17A1.33 1.33 0 119.17 7.3z" /><path d="M16.71 7.29c.52.52.52 1.36 0 1.88l-7.54 7.54a1.33 1.33 0 11-1.88-1.88l7.54-7.54a1.33 1.33 0 011.88 0z" /></g></svg>);